(() => {
  // Formulas and bay depths come from the store's existing calculator pages.
  const calculate = (family, values, pack, rollLength) => {
    const positive = (...keys) => keys.every(key => Number.isFinite(values[key]) && values[key] > 0);
    const wastage = () => Number.isFinite(values.waste) && values.waste >= 0;
    let result;
    if (family === 'paint' && positive('length', 'width', 'coats', 'coverage') && wastage() && pack > 0) {
      const area = values.length * values.width;
      const litres = area * values.coats / values.coverage * (1 + values.waste / 100);
      result = { area, litres, quantity: Math.ceil(litres / pack) };
    } else if (family === 'firewood' && positive('hours', 'days', 'weeks', 'rate') && values.hours <= 24 && values.days <= 7) {
      const hours = values.hours * values.days * values.weeks;
      const kg = hours * values.rate;
      const weight = pack || values.pack_weight;
      result = { hours, kg, quantity: weight > 0 ? Math.ceil(kg / weight) : 0 };
    } else if (family === 'markings' && positive('bays', 'depth', 'lines') && rollLength > 0 && pack > 0) {
      const metres = values.bays * values.lines * values.depth;
      const rolls = Math.ceil(metres / rollLength);
      result = { metres, rolls, quantity: Math.ceil(rolls / pack) };
    } else if (family === 'tape' && positive('length', 'runs') && wastage() && rollLength > 0) {
      const metres = values.length * values.runs * (1 + values.waste / 100);
      const rolls = Math.ceil(metres / rollLength);
      result = { metres, rolls, quantity: rolls };
    }
    if (!result || Object.values(result).some(value => !Number.isFinite(value))) throw new Error('Invalid measurements');
    return result;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = calculate;
  if (typeof document === 'undefined' || customElements.get('rss-inline-calculator')) return;
  customElements.define('rss-inline-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.strings = JSON.parse(this.querySelector('[data-calc-strings]').textContent);
      this.resultBox = this.querySelector('.rss-inline-calc-result');
      this.error = this.querySelector('.rss-inline-calc-error');
      this.useButton = this.querySelector('[data-calc-use]');
      this.inputs = [...this.querySelectorAll('[data-field]')];
      this.inputs.forEach(input => input.setAttribute('aria-label', input.closest('label').querySelector('span').textContent));
      this.querySelector('.rss-inline-calc-submit').addEventListener('click', () => this.run());
      this.useButton.addEventListener('click', () => this.useQuantity());
      this.addEventListener('input', () => { this.resultBox.hidden = true; this.error.hidden = true; this.quantity = 0; });
      this.addEventListener('change', () => { this.resultBox.hidden = true; this.error.hidden = true; this.quantity = 0; });
      this.hidden = false;
    }
    run() {
      this.error.hidden = true;
      this.resultBox.hidden = true;
      const invalid = this.inputs.find(input => !input.checkValidity());
      if (invalid) {
        const advanced = invalid.closest('.rss-inline-calc-advanced');
        if (advanced) advanced.open = true;
        invalid.reportValidity();
        return;
      }
      try {
        const values = Object.fromEntries(this.inputs.map(input => [input.dataset.field, input.value === '' ? 0 : Number(input.value)]));
        const result = calculate(this.dataset.family, values, Number(this.dataset.pack), Number(this.dataset.rollLength));
        const format = template => template.replace(/\{(\w+)\}/g, (_, key) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { maximumFractionDigits: 1 }).format(result[key]));
        let output = format(this.strings[this.dataset.family]);
        if (result.quantity && this.dataset.family !== 'paint') output += ' ' + format(this.strings.quantity);
        this.querySelector('[data-calc-result]').textContent = output;
        this.quantity = result.quantity;
        this.useButton.hidden = !this.quantity;
        this.resultBox.hidden = false;
      } catch (_) {
        this.error.textContent = this.strings.invalid;
        this.error.hidden = false;
      }
    }
    useQuantity() {
      const scope = document.getElementById(this.dataset.productSection);
      const input = scope?.querySelector('input[name="quantity"]');
      if (!input || !this.quantity) return;
      const previous = input.value;
      input.value = String(this.quantity);
      if (!input.checkValidity()) {
        input.value = previous;
        this.error.textContent = this.strings.limit;
        this.error.hidden = false;
        return;
      }
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.scrollIntoView({ block: 'center', behavior: 'auto' });
      input.focus({ preventScroll: true });
    }
  });
})();
